import { createContext, useState, useEffect, useContext } from 'react';
import { API_BASE } from '../lib/apiConfig';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedLocal = localStorage.getItem('joldipabo_admin_user');
    const storedSession = sessionStorage.getItem('joldipabo_admin_user');
    const stored = storedLocal || storedSession;
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setUser(parsed);
        setUserProfile(parsed);
      } catch (e) {
        localStorage.removeItem('joldipabo_admin_user');
        sessionStorage.removeItem('joldipabo_admin_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password, rememberMe = true) => {
    const response = await fetch(`${API_BASE}/auth/login.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    const data = await response.json();
    if (!response.ok || !data.status) {
      throw new Error(data.message || 'Login failed');
    }
    if (rememberMe) {
      localStorage.setItem('joldipabo_admin_user', JSON.stringify(data.user));
    } else {
      sessionStorage.setItem('joldipabo_admin_user', JSON.stringify(data.user));
    }
    setUser(data.user);
    setUserProfile(data.user);
    return data;
  };

  const register = async (email, password, name, role = 'data_entry') => {
    const response = await fetch(`${API_BASE}/users/register.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, name, role })
    });
    const data = await response.json();
    if (!response.ok || !data.status) {
      throw new Error(data.message || 'Registration failed');
    }
    return data;
  };

  const logout = () => {
    localStorage.removeItem('joldipabo_admin_user');
    sessionStorage.removeItem('joldipabo_admin_user');
    setUser(null);
    setUserProfile(null);
  };

  const value = {
    user,
    userProfile,
    loading,
    login,
    register,
    logout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
